<mat-dialog-content style="height: 80vh;">
    <div layout="row" layout-align="center center">
        <div style="margin-bottom: 2%;">
            <strong >{{titulo}}</strong>
        </div>
        <div class="mod-container" style="margin-top: 20px;">
            <mat-form-field style="margin-bottom: 0px; width: 60%;">
                <input matInput placeholder="Obra social" 
                    [(ngModel)]=nombre>
            </mat-form-field>
            <mat-checkbox style="width: 30%; margin-left: 20px;" [(ngModel)]="chkGravado">
                Trabaja con Gravado/No gravado
            </mat-checkbox>
        </div>
        <div>
            <mat-checkbox style="margin-bottom: 20px; margin-top: 10px;" color="primary"
                [(ngModel)]=habilitado>Habilitada
            </mat-checkbox>
            <mat-checkbox style="width: auto; margin-left: 20px;" [(ngModel)]="chkNoPlanes"
            (change)="muestraTablaPrestacionesPlan()">
                La obra social no tiene planes
            </mat-checkbox>
            <button mat-raised-button class="btn-agregar" (click)="modificarPlan('00000000-0000-0000-0000-000000000000','', true)" 
                style="padding-left: 10px; padding-right: 10px; width: 130px;
                    margin-left: 20px; cursor: pointer;" [hidden]="chkNoPlanes">
                Agregar plan
            </button>
        </div>
        <div [hidden]="!chkNoPlanes">
            <button mat-raised-button class="btn-agregar" 
                (click)="modificarPrestacionPlan('00000000-0000-0000-0000-000000000001'
                    ,'00000000-0000-0000-0000-000000000000','', '','','','1','','','','')" 
                style="padding-left: 10px; padding-right: 10px; width: 230px;
                    margin-left: 20px; cursor: pointer;">
                Agregar prestación
            </button>
            <div style="margin-left: 5%; margin-right: 5%; padding: 10px;
                        text-align: center;" [hidden]="escondeFraseNoHayPrestaciones">
                <h4 style="color: #a31611;"><b>Todavía no se agregó ninguna prestación</b></h4>
            </div>
            <div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
                [hidden]="!escondeFraseNoHayPrestaciones">
                <div fxLayout fxLayoutAlign="center center">
                    <mat-form-field fxFlex="40%">
                    <input matInput type="text" (keyup)="buscarPrestaciones($any($event.target).value)" placeholder="Búsqueda"
                        autocomplete="off"> 
                    </mat-form-field>
                </div>
                <table mat-table [dataSource]="dataSourcePrestaciones" class="mat-elevation-z8" style="width: 100%;">
                    <ng-container matColumnDef="acciones">
                        <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                        <td mat-cell *matCellDef="let element">
                            <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                                font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                                margin-top: 0px; margin-right: 3vw;"
                                (click)="modificarPrestacionPlan(element.idPlan,element.idPlanPrestacion
                                ,element.idPrestacion, element.prestacionActual,element.codigoPrestador
                                ,element.nombrePrestador,element.habilitado,element.porPresupuesto
                                ,element.tipoCoseguro,element.coseguro,element.importeOS)"
                            ></i>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="habilitado">
                        <th mat-header-cell *matHeaderCellDef style="width:10%; text-align:center;" mat-sort-header> Habilitado </th>
                        <td mat-cell *matCellDef="let element" style="text-align:center;"> 
                            <mat-checkbox [disabled]="true" [checked]="element.habilitado=='1'">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="frase" style="width:10%;">
                        <th mat-header-cell *matHeaderCellDef> Descripcion</th>
                        <td mat-cell *matCellDef="let element">
                        {{element.frase}}
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumnsPrestaciones;"></tr>">
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsPrestaciones;"></tr>
                </table>
                <mat-paginator #paginadorSoloDefecto [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
        <div [hidden]="chkNoPlanes || planesOS.length==0">
            <mat-tab-group [(selectedIndex)]=indicePlanActual (selectedTabChange)="cambiaPlan($event)">
                <mat-tab *ngFor="let plan of planesOS">
                    <ng-template mat-tab-label>
                        <strong [hidden]="!plan.habilitado">{{plan.nombre}}</strong>
                        <strong style="color: red;" [hidden]="plan.habilitado"
                            matTooltip="Plan deshabilitado">{{plan.nombre}}
                        </strong>
                        <i class="fas fa-pencil-alt fa-1x color-base" style="width: 20px; margin-left:10px;
                            font-size: 1.0em; cursor: pointer;"
                            (click)="modificarPlan(plan.idPlan,plan.nombre, plan.habilitado)"
                            matTooltip="Modificar plan"></i>
                    </ng-template>
                    <table style="margin-top: 15px; width: 95%; margin-left: 2.5%; margin-right: 2.5%;">
                        <tr>
                          <td style="width: 100%;">
                            <button mat-raised-button class="btn-agregar" (click)="modificarPrestacionPlan(plan.idPlan,'00000000-0000-0000-0000-000000000000'
                                ,'', '','','','1','','','','')" 
                                style="padding-left: 10px; padding-right: 10px; width: 230px;
                                    margin-left: 20px; cursor: pointer;">
                                Agregar prestación
                            </button>
                          </td>
                        </tr>
                    </table>
                    <div style="margin-left: 5%; margin-right: 5%; padding: 10px;
                        text-align: center;" [hidden]="escondeFraseNoHayPrestaciones">
                            <h4 style="color: #a31611;"><b>Todavía no se agregó ninguna prestación</b></h4>
                    </div>
                    <div style="margin-left: 5%; margin-right: 5%; padding-left: 20px; padding-right: 20px;" 
                        [hidden]="!escondeFraseNoHayPrestaciones">
                        <div fxLayout fxLayoutAlign="center center">
                            <mat-form-field fxFlex="40%">
                            <input matInput type="text" (keyup)="buscarPrestaciones($any($event.target).value)" placeholder="Búsqueda"
                                autocomplete="off"> 
                            </mat-form-field>
                        </div>
                        <table mat-table [dataSource]="dataSourcePrestaciones" class="mat-elevation-z8" style="width: 100%;">
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef style="width:10%;"> Acciones </th>
                                <td mat-cell *matCellDef="let element">
                                    <i class="fas fa-pencil-alt" style="width: 10px; margin-right:5%;
                                        font-size: 1.5em; cursor: pointer; color: #4b8cc5;
                                        margin-top: 0px; margin-right: 3vw;"
                                        (click)="modificarPrestacionPlan(element.idPlan,element.idPlanPrestacion
                                        ,element.idPrestacion, element.prestacionActual,element.codigoPrestador
                                        ,element.nombrePrestador,element.habilitado,element.porPresupuesto
                                        ,element.tipoCoseguro,element.coseguro,element.importeOS)"
                                    ></i>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="habilitado">
                                <th mat-header-cell *matHeaderCellDef style="width:10%; text-align:center;" mat-sort-header> Habilitado </th>
                                <td mat-cell *matCellDef="let element" style="text-align:center;"> 
                                    <mat-checkbox [disabled]="true" [checked]="element.habilitado=='1'">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="frase" style="width:10%;">
                                <th mat-header-cell *matHeaderCellDef> Descripcion</th>
                                <td mat-cell *matCellDef="let element">
                                {{element.frase}}
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumnsPrestaciones;"></tr>">
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsPrestaciones;"></tr>
                        </table>
                        <mat-paginator #paginador [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
                    </div>
                </mat-tab>
            </mat-tab-group>
        </div>
    </div>
</mat-dialog-content>
<div style="text-align: center;">
    <table style="width: 100%; text-align: center;">
        <tr>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="cerrar('cancela')">
                    <i class="fas fa-arrow-circle-left fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Cancelar
                </button>
            </td>
            <td style="width: 20%;"></td>
            <td style="width: 30%;">
                <button mat-raised-button class="btn-agregar" (click)="almacenar()" style="margin-left: 30px;">
                    <i class="fas fa-save fa-1x" style="width: 20px; margin-right:10px;
                                    font-size: 1.5em; cursor: pointer;"></i>
                    Almacenar
                </button>
            </td>
        </tr>
    </table>
</div>
